import type { Dictionary, InstanceManagementMessages } from '../../models'

import { LocaleEnum, ServiceConfigFieldErrorEnum } from '../../enums'

import {
  USER_ROLE_MANAGEMENT_MESSAGES_EN,
  USER_ROLE_MANAGEMENT_MESSAGES_ES,
} from '../user-role-management.messages'
import {
  SEARCH_SERVICE_CONFIG_MESSAGES_EN,
  SEARCH_SERVICE_CONFIG_MESSAGES_ES,
} from './search-service-config.messages'

const INSTANCE_MANAGEMENT_MESSAGES_EN: InstanceManagementMessages = {
  requestNewInstance: {
    title: 'Request an instance',
    input: {
      label: 'Instance display name',
      placeholder: 'Name used to identify the instance',
      error: 'Instance name must be alphanumeric and can contain hyphens. Spaces are not allowed.',
    },
    actions: {
      save: 'Save',
      cancel: 'Cancel',
    },
    success: 'Instance created successfully',
    error: 'Failed to create instance. Please try again.',
  },
  instanceId: 'Instance ID',
  serviceConfig: {
    fieldErrors: {
      [ServiceConfigFieldErrorEnum.REQUIRED]: 'Required field',
      [ServiceConfigFieldErrorEnum.ARRAY_UNIQUE_ITEMS]: 'Value must not be repeated',
      [ServiceConfigFieldErrorEnum.ARRAY_MIN_ITEMS]: 'Enter at least {minItems} values',
      [ServiceConfigFieldErrorEnum.ARRAY_MIN_ITEMS_ONE]: 'Enter at least one value',
      [ServiceConfigFieldErrorEnum.ARRAY_MAX_ITEMS]: 'Enter up to {maxItems} values',
      [ServiceConfigFieldErrorEnum.ARRAY_MAX_ITEMS_ONE]: 'Enter up to one value',
      [ServiceConfigFieldErrorEnum.STRING_PATTERN]:
        'Value entered must match the format: {pattern}',
      [ServiceConfigFieldErrorEnum.STRING_ENUM]: 'Select a valid option: {enum}',
      [ServiceConfigFieldErrorEnum.STRING_MIN_LENGTH]:
        'Value must be at least {minLength} characters',
      [ServiceConfigFieldErrorEnum.STRING_MAX_LENGTH]:
        'Value must be no more than {maxLength} characters',
      [ServiceConfigFieldErrorEnum.NUMBER_INVALID_TYPE]: 'Enter a number',
      [ServiceConfigFieldErrorEnum.NUMBER_INTEGER]: 'Enter a whole number',
      [ServiceConfigFieldErrorEnum.NUMBER_MINIMUM]: 'Value must be {minimum} or greater',
      [ServiceConfigFieldErrorEnum.NUMBER_EXCLUSIVE_MINIMUM]:
        'Value must be greater than {exclusiveMinimum}',
      [ServiceConfigFieldErrorEnum.NUMBER_MAXIMUM]: 'Value must be {maximum} or less',
      [ServiceConfigFieldErrorEnum.NUMBER_EXCLUSIVE_MAXIMUM]:
        'Value must be less than {exclusiveMaximum}',
      [ServiceConfigFieldErrorEnum.NUMBER_MULTIPLE_OF]: 'Value must be a multiple of {multipleOf}',
      [ServiceConfigFieldErrorEnum.JSON_FORMAT]: 'Json format is not valid: {message}',
    },
    actions: {
      save: {
        label: 'Save',
        success: 'Changes saved successfully',
      },
      enable: {
        label: 'Deactivated',
        success: 'Service activated successfully',
      },
      disable: {
        label: 'Activated',
        success: 'Service deactivated successfully',
      },
    },
    services: {
      search: SEARCH_SERVICE_CONFIG_MESSAGES_EN,
      userRoleManagement: USER_ROLE_MANAGEMENT_MESSAGES_EN,
    },
  },
}

const INSTANCE_MANAGEMENT_MESSAGES_ES: InstanceManagementMessages = {
  requestNewInstance: {
    title: '',
    input: {
      label: '',
      placeholder: '',
      error: '',
    },
    actions: {
      save: '',
      cancel: '',
    },
    success: '',
    error: '',
  },
  instanceId: 'ID de la instancia',
  serviceConfig: {
    fieldErrors: {
      [ServiceConfigFieldErrorEnum.REQUIRED]: 'Campo obligatorio',
      [ServiceConfigFieldErrorEnum.ARRAY_UNIQUE_ITEMS]: 'El valor está repetido',
      [ServiceConfigFieldErrorEnum.ARRAY_MIN_ITEMS]: 'Especifica al menos {minItems} valores',
      [ServiceConfigFieldErrorEnum.ARRAY_MIN_ITEMS_ONE]: 'Especifica al menos un valor',
      [ServiceConfigFieldErrorEnum.ARRAY_MAX_ITEMS]:
        'Especifica hasta {maxItems} valores como máximo',
      [ServiceConfigFieldErrorEnum.ARRAY_MAX_ITEMS_ONE]: 'Especifica solo un valor',
      [ServiceConfigFieldErrorEnum.STRING_PATTERN]:
        'El valor especificado no coincide con el formato: {pattern}',
      [ServiceConfigFieldErrorEnum.STRING_ENUM]: 'Selecciona una opción válida: {enum}',
      [ServiceConfigFieldErrorEnum.STRING_MIN_LENGTH]:
        'El valor especificado debe tener al menos {minLength} caracteres',
      [ServiceConfigFieldErrorEnum.STRING_MAX_LENGTH]:
        'El valor especificado no debe tener más de {maxLength} caracteres',
      [ServiceConfigFieldErrorEnum.NUMBER_INVALID_TYPE]: 'Especifica un valor numérico',
      [ServiceConfigFieldErrorEnum.NUMBER_INTEGER]: 'Especifica un número entero (sin decimales)',
      [ServiceConfigFieldErrorEnum.NUMBER_MINIMUM]:
        'El valor especificado debe ser {minimum} o mayor',
      [ServiceConfigFieldErrorEnum.NUMBER_EXCLUSIVE_MINIMUM]:
        'El valor especificado debe ser mayor que {exclusiveMinimum}',
      [ServiceConfigFieldErrorEnum.NUMBER_MAXIMUM]:
        'El valor especificado debe ser {maximum} o menor',
      [ServiceConfigFieldErrorEnum.NUMBER_EXCLUSIVE_MAXIMUM]:
        'El valor especificado debe ser menor que {exclusiveMaximum}',
      [ServiceConfigFieldErrorEnum.NUMBER_MULTIPLE_OF]:
        'El valor especificado debe ser un múltiplo de {multipleOf}',
      [ServiceConfigFieldErrorEnum.JSON_FORMAT]: 'El formato del Json no es válido: {message}',
    },
    actions: {
      save: {
        label: 'Guardar',
        success: 'Cambios guardados con éxito',
      },
      enable: {
        label: 'Deshabilitado',
        success: 'Servicio habilitado con éxito',
      },
      disable: {
        label: 'Habilitado',
        success: 'Servicio deshabilitado con éxito',
      },
    },
    services: {
      search: SEARCH_SERVICE_CONFIG_MESSAGES_ES,
      userRoleManagement: USER_ROLE_MANAGEMENT_MESSAGES_ES,
    },
  },
}

export const INSTANCE_MANAGEMENT_MESSAGES: Dictionary<{
  instanceManagement: InstanceManagementMessages
}> = {
  [LocaleEnum.ENGLISH]: {
    instanceManagement: INSTANCE_MANAGEMENT_MESSAGES_EN,
  },
  [LocaleEnum.SPANISH]: {
    instanceManagement: INSTANCE_MANAGEMENT_MESSAGES_ES,
  },
}
